import Axios from 'axios'
import { getPathName, retryRequest, getApiHash, getApiToken } from './helper';

const guardarContacto = async (rubro, origen, tipoCotizador, landingUrl, refererUrl, patente, marca, modelo, version, anio, email, codigoArea, telefono, fechaNacimiento, sexo, provincia, localidad, nombre, apellido, cuandoContrata, captchaToken) => {
  const params = {
    hash: await getApiHash(),
    isMobile: "false",
    rubro: rubro,
    origen: origen,
    tipoCotizador: tipoCotizador,
    landingUrl: landingUrl,
    refererUrl: refererUrl,
    patente: patente,
    marca: marca,
    modelo: modelo,
    version: version,
    anio: anio,
    email: email,
    codigoArea: codigoArea,
    telefono: telefono,
    fechaNacimiento: fechaNacimiento,
    sexo: sexo,
    provincia: provincia,
    localidad: localidad,
    nombre: nombre,
    apellido: apellido,
    cuandoContrata: cuandoContrata,
    g_recaptcha_response: captchaToken
  }

  const headers = {
    'content-type': 'application/json',
    "Authorization": 'Bearer ' + await getApiToken()
  }

  let endpoint = "/setcotizacionjson"
  if (process.env.REACT_APP_DEV_MODE === "true") {
    if (process.env.REACT_APP_PAIS == "uy") endpoint = "/setcotizacionvehiculojson"
  } else {
    const hostname = window.location.hostname;
    if (hostname.endsWith(".com.uy")) {
      endpoint = "/setcotizacionvehiculojson"
    } else {
      endpoint = "/setcotizacionjson"
    }
  }

  const axiosPostRequest = async () => {
    return Axios.post(await getPathName() + endpoint, params, {
      headers: headers
    });
  };

  try {
    const response = await retryRequest(axiosPostRequest);
    return response;
  } catch (error) {
    console.error('Fallo de hacer varios intentos: ' + error.message);
    return error;
  }
};



export default guardarContacto;